// document.addEventListener("DOMContentLoaded", function () {
//   const checkInterval = setInterval(() => {
//     const options = document.querySelectorAll(".bold_option_radio");

//     if (options.length > 0) {
//       clearInterval(checkInterval);

//       document.querySelectorAll(".bold_option_radio .bold_option_title").forEach((title, index) => {
//         if (!title.querySelector(".option-number")) {
//           const numSpan = document.createElement("span");
//           numSpan.className = "option-number";
//           numSpan.textContent = `${index + 1}`;
//           title.prepend(numSpan);
//         }
//       });

//       options.forEach((o, i) => {
//         if (i === 0) o.classList.add("active");
//       });

//       options.forEach(option => {
//         const radios = option.querySelectorAll("input[type='radio']");

//         radios.forEach(radio => {
//           radio.addEventListener("change", function (e) {
//             if (option.classList.contains("active") && e.target.type === "radio") {
//               triggerContinue(option);
//             }
//           });

//           radio.addEventListener("click", function (e) {
//             if (option.classList.contains("active")) {
//               setTimeout(() => {
//                 triggerContinue(option);
//               }, 0);
//             }
//           });
//         });
//       });

//       document.addEventListener("click", function (e) {
//         if (e.target.classList.contains("edit-btn") || e.target.closest(".edit-btn")) {
//           e.preventDefault();
//           e.stopPropagation();

//           const editBtn = e.target.classList.contains("edit-btn") ? e.target : e.target.closest(".edit-btn");
//           const selectedOption = editBtn.closest(".bold_option_radio");
//           if (!selectedOption) return;

//           editBtn.remove();

//           const radios = selectedOption.querySelectorAll("input[type='radio']");
//           radios.forEach(radio => (radio.checked = false));

//           selectedOption.classList.remove("selected");
//           selectedOption.classList.add("active");

//           document.querySelectorAll(".bold_option_radio").forEach(o => {
//             if (o !== selectedOption) {
//               const hasCheckedRadio = Array.from(o.querySelectorAll('input[type="radio"]')).some(radio => radio.checked);
//               if (hasCheckedRadio) {
//                 o.classList.add("selected");
//                 o.classList.remove("active");
//               } else {
//                 o.classList.remove("selected");
//                 o.classList.remove("active");
//               }
//             }
//           });

//           checkAndUpdateSummaryAfterEdit();

//           const stickyCartShow = document.getElementById("sticky-cart");
//           if (stickyCartShow) stickyCartShow.classList.remove("show");

//           const CompleteBox = document.querySelector(".custom-atc-wrapper");
//           if (CompleteBox) CompleteBox.classList.remove("show");
//         }
//       });
//     }
//   }, 300);

//   function areAllOptionsSelected() {
//     const allOptions = document.querySelectorAll(".bold_option_radio");
//     const selectedOptions = document.querySelectorAll(".bold_option_radio.selected");
    
//     return allOptions.length > 0 && allOptions.length === selectedOptions.length;
//   }

//   function isOptionValid(option) {
//     const checkedRadios = option.querySelectorAll('input[type="radio"]:checked');
//     return checkedRadios.length > 0;
//   }

//   function triggerContinue(activeOption) {
//     if (!activeOption) return;

//     if (activeOption.classList.contains("selected")) {
//       return;
//     }

//     activeOption.classList.remove("active");
//     activeOption.classList.add("selected");

//     const title = activeOption.querySelector(".bold_option_title");
//     if (title && !title.querySelector(".edit-btn")) {
//       const editBtn = document.createElement("button");
//       editBtn.type = "button";
//       editBtn.className = "edit-btn";
//       editBtn.innerHTML = `<span class="edit-icon">✎</span><span>Edit</span>`;
//       title.appendChild(editBtn);
//     }

//     const nextOption = activeOption.nextElementSibling;
//     if (nextOption && nextOption.classList.contains("bold_option_radio")) {
//       nextOption.classList.add("active");
//       nextOption.scrollIntoView({ behavior: "smooth", block: "center" });
//     }

//     if (areAllOptionsSelected()) {
//       showConfigurationSummary();

//       const stickyCartShow = document.getElementById("sticky-cart");
//       if (stickyCartShow) stickyCartShow.classList.add("show");

//       const CompleteBox = document.querySelector(".custom-atc-wrapper");
//       if (CompleteBox) CompleteBox.classList.add("show");
//     } else {
//       hideConfigurationSummary();
      
//       const stickyCartShow = document.getElementById("sticky-cart");
//       if (stickyCartShow) stickyCartShow.classList.remove("show");

//       const CompleteBox = document.querySelector(".custom-atc-wrapper");
//       if (CompleteBox) CompleteBox.classList.remove("show");
//     }
//   }

//   function checkAndUpdateSummaryAfterEdit() {
//     if (areAllOptionsSelected()) {
//       const hasAllValidOptions = Array.from(document.querySelectorAll(".bold_option_radio.selected")).every(option => isOptionValid(option));
      
//       if (hasAllValidOptions) {
//         updateConfigurationSummary();
//       } else {
//         hideConfigurationSummary();
//       }
//     } else {
//       hideConfigurationSummary();
//     }
//   }

//   function showConfigurationSummary() {
//     if (!areAllOptionsSelected()) return;

//     const priceContainer = document.querySelector(".price__container[data-price]");
    
//     const existingTotalBox = document.querySelector(".bold_option_total");
//     if (existingTotalBox) {
//       existingTotalBox.remove();
//     }
    
//     const totalBox = document.createElement("div");
//     totalBox.className = "bold_option_total";
    
//     const basePrice = priceContainer ? (parseFloat(priceContainer.getAttribute("data-price")) / 100 || 0) : 0;

//     const checkedInputs = document.querySelectorAll(".bold_option_radio.selected input[type='radio']:checked");
//     let selectedSum = 0;

//     checkedInputs.forEach(input => {
//       const optionValue = input.closest(".bold_option_value");
//       if (optionValue) {
//         const priceEl = optionValue.querySelector(".bold_option_value_price");
//         if (priceEl) {
//           const val = priceEl.textContent.replace(/[^0-9.]/g, "");
//           const num = parseFloat(val);
//           if (!isNaN(num)) selectedSum += num;
//         }
//       }
//     });

//     const total = (basePrice + selectedSum).toFixed(2);

//     const summaryBox = document.createElement("div");
//     summaryBox.className = "config-summary";
//     summaryBox.style.display = "block";
//     summaryBox.style.visibility = "visible";
    
//     summaryBox.innerHTML = `
//       <div class="config-header">Configuration Complete - Ready to Add to Cart!</div>
//       <div class="config-line"><span>Base Kit Price:</span><span class="config-value">$${basePrice.toFixed(2)}</span></div>
//       <div class="config-line"><span>Selected Options:</span><span class="config-value option">+${selectedSum > 0 ? "$" + selectedSum.toFixed(2) : "$0.00"}</span></div>
//       <div class="config-line total"><strong>Total Price:</strong><strong class="config-total">$${total}</strong></div>
//     `;

//     totalBox.appendChild(summaryBox);
    
//     const possibleContainers = [
//       document.querySelector(".bold_options_container"),
//       document.querySelector(".bold_options"),
//       document.querySelector(".product-form"),
//       document.body
//     ];
    
//     let inserted = false;
//     for (let container of possibleContainers) {
//       if (container) {
//         container.appendChild(totalBox);
//         inserted = true;
//         break;
//       }
//     }
    
//     if (!inserted) {
//       document.body.appendChild(totalBox);
//     }
    
//     totalBox.classList.add("show");
//     totalBox.style.display = 'block';
//     summaryBox.style.display = 'block';
    
//     setTimeout(syncPrices, 150);
//   }

//   function updateConfigurationSummary() {
//     const priceContainer = document.querySelector(".price__container[data-price]");
//     const totalBox = document.querySelector(".bold_option_total");
    
//     if (!totalBox) {
//       showConfigurationSummary();
//       return;
//     }
    
//     const basePrice = priceContainer ? (parseFloat(priceContainer.getAttribute("data-price")) / 100 || 0) : 0;

//     const checkedInputs = document.querySelectorAll(".bold_option_radio.selected input[type='radio']:checked");
//     let selectedSum = 0;

//     checkedInputs.forEach(input => {
//       const optionValue = input.closest(".bold_option_value");
//       if (optionValue) {
//         const priceEl = optionValue.querySelector(".bold_option_value_price");
//         if (priceEl) {
//           const val = priceEl.textContent.replace(/[^0-9.]/g, "");
//           const num = parseFloat(val);
//           if (!isNaN(num)) selectedSum += num;
//         }
//       }
//     });

//     const total = (basePrice + selectedSum).toFixed(2);

//     const summaryBox = totalBox.querySelector(".config-summary");
//     if (summaryBox) {
//       summaryBox.innerHTML = `
//         <div class="config-header">Configuration Complete - Ready to Add to Cart!</div>
//         <div class="config-line"><span>Base Kit Price:</span><span class="config-value">$${basePrice.toFixed(2)}</span></div>
//         <div class="config-line"><span>Selected Options:</span><span class="config-value option">+${selectedSum > 0 ? "$" + selectedSum.toFixed(2) : "$0.00"}</span></div>
//         <div class="config-line total"><strong>Total Price:</strong><strong class="config-total">$${total}</strong></div>
//       `;
//     } else {
//       const newSummaryBox = document.createElement("div");
//       newSummaryBox.className = "config-summary";
//       newSummaryBox.style.display = "block";
//       newSummaryBox.style.visibility = "visible";
      
//       newSummaryBox.innerHTML = `
//         <div class="config-header">Configuration Complete - Ready to Add to Cart!</div>
//         <div class="config-line"><span>Base Kit Price:</span><span class="config-value">$${basePrice.toFixed(2)}</span></div>
//         <div class="config-line"><span>Selected Options:</span><span class="config-value option">+${selectedSum > 0 ? "$" + selectedSum.toFixed(2) : "$0.00"}</span></div>
//         <div class="config-line total"><strong>Total Price:</strong><strong class="config-total">$${total}</strong></div>
//       `;
      
//       totalBox.appendChild(newSummaryBox);
//     }
    
//     totalBox.classList.add("show");
//     totalBox.style.display = 'block';
    
//     setTimeout(syncPrices, 150);
//   }

//   function hideConfigurationSummary() {
//     const existingTotalBox = document.querySelector(".bold_option_total");
//     if (existingTotalBox) {
//       existingTotalBox.remove();
//     }
//   }

//   function syncPrices() {
//     const sourcePrice = document.querySelector('.config-total');
    
//     const target1 = document.querySelector('.product-price');
//     const target2 = document.querySelector('.sticky-cart__price');
    
//     if (sourcePrice) {
//       const priceText = sourcePrice.textContent.trim();
      
//       if (target1) {
//         target1.textContent = priceText;
//       }
      
//       if (target2) {
//         target2.textContent = priceText;
//       }
//     }
//   }

//   const style = document.createElement('style');
//   style.textContent = `
//     .config-header {
//       font-weight: bold;
//       font-size: 16px;
//       margin-bottom: 12px;
//       color: #333;
//       text-align: left;
//     }
    
//     .config-line {
//       display: flex;
//       justify-content: space-between;
//       margin-bottom: 8px;
//       font-size: 14px;
//     }
    
//     .config-line.total {
//       margin-top: 10px;
//       padding-top: 10px;
//       border-top: 1px solid #ddd;
//       font-size: 16px;
//     }
    
//     .config-value {
//       font-weight: 500;
//     }
    
//     .config-value.option {
//       color: #007bff;
//     }
    
//     .config-total {
//       color: #d32f2f;
//       font-size: 17px;
//     }
    
//     .bold_option_total.show {
//       display: block;
//     }
    
//     .bold_option_total.show .config-summary,
//     .bold_option_total .config-summary {
//       display: block !important;
//     }
//   `;
//   document.head.appendChild(style);

//   setTimeout(syncPrices, 1000);

//   document.addEventListener('change', function(e) {
//     if (e.target.matches('input[name="id"], select[name="id"], .product-option input')) {
//       setTimeout(syncPrices, 200);
//     }
//   });

//   setInterval(syncPrices, 500);
//   window.syncAllPrices = syncPrices;
// });


// document.addEventListener("DOMContentLoaded", function () {
//   const checkInterval = setInterval(() => {
//     const options = document.querySelectorAll(".bold_option_radio");

//     if (options.length > 0) {
//       clearInterval(checkInterval);
//       console.log("✅ .bold_option_radio elements loaded");

//     // 🔢 Add numbering before each .bold_option_title
//     document.querySelectorAll(".bold_option_radio .bold_option_title").forEach((title, index) => {
//       if (!title.querySelector(".option-number")) {
//         const numSpan = document.createElement("span");
//         numSpan.className = "option-number";
//         numSpan.textContent = `${index + 1}`;
//         title.prepend(numSpan);
//       }
//     });

//       // 1️⃣ Make the first option active by default
//       options[0].classList.add("active");

//       // 2️⃣ When a radio button inside the active option is checked → show Continue button
//       options.forEach(option => {
//         option.addEventListener("change", function (e) {
//           if (option.classList.contains("active") && e.target.type === "radio") {
//             if (!option.querySelector(".continue-btn")) {
//               const btn = document.createElement("button");
//               btn.className = "continue-btn";
//               btn.textContent = "CONTINUE";
//               option.appendChild(btn);
//             }
//           }
//         });
//       });

//       // 3️⃣ Continue button click → mark selected, add Edit button, activate next option
//       document.addEventListener("click", function (e) {
//         if (e.target.classList.contains("continue-btn")) {
//           const activeOption = e.target.closest(".bold_option_radio");
//           if (!activeOption) return;

//           e.target.remove();
//           activeOption.classList.remove("active");
//           activeOption.classList.add("selected");

//           // ✅ Add Edit button inside .bold_option_title
//           const title = activeOption.querySelector(".bold_option_title");
//           if (title && !title.querySelector(".edit-btn")) {
//             const editBtn = document.createElement("button");
//             editBtn.className = "edit-btn";
//             editBtn.innerHTML = `<span class="edit-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-pen h-3 w-3 mr-1" aria-hidden="true"><path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z"></path></svg></span><span>Edit</span>`;
//             title.appendChild(editBtn);
//           }

//           // Activate next option or show summary if all done
//           const nextOption = activeOption.nextElementSibling;
//           if (nextOption && nextOption.classList.contains("bold_option_radio")) {
//             nextOption.classList.add("active");
//           } else {
//             // ✅ Last option done → show total box and summary
//             const totalBox = document.querySelector(".bold_option_total");
//             if (totalBox) {
//               totalBox.classList.add("show"); // add class to reveal total box
//             }

//             showConfigurationSummary(); // append config-summary inside .bold_option_total
//           }
//         }
//       });

//       // 4️⃣ Edit button click → uncheck, remove selected, make active again
//       document.addEventListener("click", function (e) {
//         if (e.target.classList.contains("edit-btn")) {
//           const selectedOption = e.target.closest(".bold_option_radio");
//           if (!selectedOption) return;

//           e.target.remove();

//           const radios = selectedOption.querySelectorAll("input[type='radio']");
//           radios.forEach(radio => (radio.checked = false));

//           document
//             .querySelectorAll(".bold_option_radio")
//             .forEach(o => o.classList.remove("active"));
//           selectedOption.classList.remove("selected");
//           selectedOption.classList.add("active");

//           const contBtn = selectedOption.querySelector(".continue-btn");
//           if (contBtn) contBtn.remove();

//           const summary = document.querySelector(".config-summary");
//           if (summary) summary.remove();

//           // Hide total box again when editing
//           const totalBox = document.querySelector(".bold_option_total");
//           if (totalBox) totalBox.classList.remove("show");
//         }
//       });
//     }
//   }, 300); // check every 300ms

//   function showConfigurationSummary() {
//     const priceContainer = document.querySelector(".price__container[data-price]");
//     const totalBox = document.querySelector(".bold_option_total");

//     if (!priceContainer || !totalBox) {
//         console.warn("⚠️ Price or total box not found");
//         return;
//     }

//     // Extract base price
//     const basePrice = parseFloat(priceContainer.getAttribute("data-price")) / 100 || 0;

//     // Sum of selected options
//     const checkedInputs = document.querySelectorAll(".bold_option_radio.selected input[type='radio']:checked");
//     let selectedSum = 0;

//     checkedInputs.forEach(input => {
//         const optionValue = input.closest(".bold_option_value");
//         if (optionValue) {
//             const priceEl = optionValue.querySelector(".bold_option_value_price");
//             if (priceEl) {
//                 const val = priceEl.textContent.replace(/[^0-9.]/g, "");
//                 const num = parseFloat(val);
//                 if (!isNaN(num)) selectedSum += num;
//             }
//         }
//     });

//     const total = (basePrice + selectedSum).toFixed(2);

//     // Remove old summary if exists
//     const oldSummary = totalBox.querySelector(".config-summary");
//     if (oldSummary) oldSummary.remove();

//     // Create summary box
//     const summaryBox = document.createElement("div");
//     summaryBox.className = "config-summary";
//     summaryBox.innerHTML = `
//       <div class="config-header">
//         <span class="config-header-icon">
//           <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-check-big h-5 w-5 mr-2" aria-hidden="true"><path d="M21.801 10A10 10 0 1 1 17 3.335"></path><path d="m9 11 3 3L22 4"></path></svg>
//         </span>
//         Configuration Complete - Ready to Add to Cart!
//       </div>
//       <div class="config-line">
//         <span>Base Kit Price:</span>
//         <span class="config-value">$${basePrice.toFixed(2)}</span>
//       </div>
//       <div class="config-line">
//         <span>Selected Options:</span>
//         <span class="config-value option">+${selectedSum > 0 ? "$" + selectedSum.toFixed(2) : "$0.00"}</span>
//       </div>
//       <div class="config-line total">
//         <strong>Total Extras:</strong>
//         <strong class="config-total">$${total}</strong>
//       </div>
//     `;

//     // ✅ Append summary inside .bold_option_total
//     totalBox.appendChild(summaryBox);
//   }
// });


// // mini new js
// document.addEventListener("DOMContentLoaded", function () {
//   const checkInterval = setInterval(() => {
//     const options = document.querySelectorAll(".bold_option_radio");

//     if (options.length > 0) {
//       clearInterval(checkInterval);
//       console.log("✅ .bold_option_radio elements loaded");

//       // 🔢 Add numbering before each .bold_option_title
//       document.querySelectorAll(".bold_option_radio .bold_option_title").forEach((title, index) => {
//         if (!title.querySelector(".option-number")) {
//           const numSpan = document.createElement("span");
//           numSpan.className = "option-number";
//           numSpan.textContent = `${index + 1}`;
//           title.prepend(numSpan);
//         }
//       });

//       // 1️⃣ Make the first option active by default
//       options[0].classList.add("active");

//       // 2️⃣ When a radio button inside the active option is checked → show Continue button
//       options.forEach(option => {
//         option.addEventListener("change", function (e) {
//           if (option.classList.contains("active") && e.target.type === "radio") {
//             if (!option.querySelector(".continue-btn")) {
//               const btn = document.createElement("button");
//               btn.type = "button"; // ✅ Prevent form submission
//               btn.className = "continue-btn";
//               btn.textContent = "CONTINUE";
//               option.appendChild(btn);
//             }
//           }
//         });
//       });

//       // 3️⃣ Continue button click → mark selected, add Edit button, activate next option
//       document.addEventListener("click", function (e) {
//         if (e.target.classList.contains("continue-btn")) {
//           e.preventDefault();
//           e.stopPropagation();

//           const activeOption = e.target.closest(".bold_option_radio");
//           if (!activeOption) return;

//           e.target.remove();
//           activeOption.classList.remove("active");
//           activeOption.classList.add("selected");

//           // ✅ Add Edit button inside .bold_option_title
//           const title = activeOption.querySelector(".bold_option_title");
//           if (title && !title.querySelector(".edit-btn")) {
//             const editBtn = document.createElement("button");
//             editBtn.type = "button"; // ✅ Prevent form submission
//             editBtn.className = "edit-btn";
//             editBtn.innerHTML = `
//               <span class="edit-icon">
//                 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
//                   stroke="currentColor" stroke-width="2" stroke-linecap="round"
//                   stroke-linejoin="round" class="lucide lucide-square-pen h-3 w-3 mr-1" aria-hidden="true">
//                   <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
//                   <path d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z"></path>
//                 </svg>
//               </span>
//               <span>Edit</span>
//             `;
//             title.appendChild(editBtn);
//           }

//           // Activate next option or show summary if all done
//           const nextOption = activeOption.nextElementSibling;
//           if (nextOption && nextOption.classList.contains("bold_option_radio")) {
//             nextOption.classList.add("active");
//           } else {
//             // ✅ Last option done → show total box and summary
//             const totalBox = document.querySelector(".bold_option_total");
//             if (totalBox) {
//               totalBox.classList.add("show"); // add class to reveal total box
//             }

//             showConfigurationSummary(); // append config-summary inside .bold_option_total
//           }
//         }
//       });

//       // 4️⃣ Edit button click → uncheck, remove selected, make active again
//       document.addEventListener("click", function (e) {
//         if (e.target.classList.contains("edit-btn")) {
//           e.preventDefault();
//           e.stopPropagation();

//           const selectedOption = e.target.closest(".bold_option_radio");
//           if (!selectedOption) return;

//           e.target.remove();

//           const radios = selectedOption.querySelectorAll("input[type='radio']");
//           radios.forEach(radio => (radio.checked = false));

//           document.querySelectorAll(".bold_option_radio").forEach(o => o.classList.remove("active"));
//           selectedOption.classList.remove("selected");
//           selectedOption.classList.add("active");

//           const contBtn = selectedOption.querySelector(".continue-btn");
//           if (contBtn) contBtn.remove();

//           const summary = document.querySelector(".config-summary");
//           if (summary) summary.remove();

//           // Hide total box again when editing
//           const totalBox = document.querySelector(".bold_option_total");
//           if (totalBox) totalBox.classList.remove("show");
//         }
//       });
//     }
//   }, 300); // check every 300ms

//   // ✅ Function to show configuration summary
//   function showConfigurationSummary() {
//     const priceContainer = document.querySelector(".price__container[data-price]");
//     const totalBox = document.querySelector(".bold_option_total");

//     if (!priceContainer || !totalBox) {
//       console.warn("⚠️ Price or total box not found");
//       return;
//     }

//     // Extract base price
//     const basePrice = parseFloat(priceContainer.getAttribute("data-price")) / 100 || 0;

//     // Sum of selected options
//     const checkedInputs = document.querySelectorAll(".bold_option_radio.selected input[type='radio']:checked");
//     let selectedSum = 0;

//     checkedInputs.forEach(input => {
//       const optionValue = input.closest(".bold_option_value");
//       if (optionValue) {
//         const priceEl = optionValue.querySelector(".bold_option_value_price");
//         if (priceEl) {
//           const val = priceEl.textContent.replace(/[^0-9.]/g, "");
//           const num = parseFloat(val);
//           if (!isNaN(num)) selectedSum += num;
//         }
//       }
//     });

//     const total = (basePrice + selectedSum).toFixed(2);

//     // Remove old summary if exists
//     const oldSummary = totalBox.querySelector(".config-summary");
//     if (oldSummary) oldSummary.remove();

//     // Create summary box
//     const summaryBox = document.createElement("div");
//     summaryBox.className = "config-summary";
//     summaryBox.innerHTML = `
//       <div class="config-header">
//         <span class="config-header-icon">
//           <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
//             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
//             class="lucide lucide-circle-check-big h-5 w-5 mr-2" aria-hidden="true">
//             <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
//             <path d="m9 11 3 3L22 4"></path>
//           </svg>
//         </span>
//         Configuration Complete - Ready to Add to Cart!
//       </div>
//       <div class="config-line">
//         <span>Base Kit Price:</span>
//         <span class="config-value">$${basePrice.toFixed(2)}</span>
//       </div>
//       <div class="config-line">
//         <span>Selected Options:</span>
//         <span class="config-value option">+${selectedSum > 0 ? "$" + selectedSum.toFixed(2) : "$0.00"}</span>
//       </div>
//       <div class="config-line total">
//         <strong>Total Extras:</strong>
//         <strong class="config-total">$${total}</strong>
//       </div>
//     `;

//     // ✅ Append summary inside .bold_option_total
//     totalBox.appendChild(summaryBox);
//   }
// });


// document.addEventListener("DOMContentLoaded", function () {
//   const checkInterval = setInterval(() => {
//     const options = document.querySelectorAll(".bold_option_radio");

//     if (options.length > 0) {
//       clearInterval(checkInterval);
//       console.log("✅ .bold_option_radio elements loaded");
//       document.querySelectorAll(".bold_option_radio .bold_option_title").forEach((title, index) => {
//         if (!title.querySelector(".option-number")) {
//           const numSpan = document.createElement("span");
//           numSpan.className = "option-number";
//           numSpan.textContent = `${index + 1}`;
//           title.prepend(numSpan);
//         }
//       });

//       options[0].classList.add("active");

//       options.forEach(option => {
//         option.addEventListener("change", function (e) {
//           if (option.classList.contains("active") && e.target.type === "radio") {
//             triggerContinue(option);
//           }
//         });
//       });
      

//       document.addEventListener("click", function (e) {
//         if (e.target.classList.contains("edit-btn")) {
//           e.preventDefault();
//           e.stopPropagation();

//           const selectedOption = e.target.closest(".bold_option_radio");
//           if (!selectedOption) return;

//           e.target.remove();

//           const radios = selectedOption.querySelectorAll("input[type='radio']");
//           radios.forEach(radio => (radio.checked = false));
//           document.querySelectorAll(".bold_option_radio").forEach(o => o.classList.remove("active"));
//           selectedOption.classList.remove("selected");
//           selectedOption.classList.add("active");

//           console.log("🟢 Edit clicked — keeping total box visible");
//         }
//       });
//     }
//   }, 300); 

//   function triggerContinue(activeOption) {
//     if (!activeOption) return;

//     activeOption.classList.remove("active");
//     activeOption.classList.add("selected");

//     const title = activeOption.querySelector(".bold_option_title");
//     if (title && !title.querySelector(".edit-btn")) {
//       const editBtn = document.createElement("button");
//       editBtn.type = "button";
//       editBtn.className = "edit-btn";
//       editBtn.innerHTML = `
//         <span class="edit-icon">
//           <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
//             stroke="currentColor" stroke-width="2" stroke-linecap="round"
//             stroke-linejoin="round" class="lucide lucide-square-pen h-3 w-3 mr-1" aria-hidden="true">
//             <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
//             <path d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z"></path>
//           </svg>
//         </span>
//         <span>Edit</span>
//       `;
//       title.appendChild(editBtn);
//     }

//     const nextOption = activeOption.nextElementSibling;
//     if (nextOption && nextOption.classList.contains("bold_option_radio")) {
//       nextOption.classList.add("active");
//     } else {
//       const totalBox = document.querySelector(".bold_option_total");
//       if (totalBox) totalBox.classList.add("show");
//       showConfigurationSummary();

//       const stickyCartShow = document.getElementById("sticky-cart");
//       stickyCartShow.classList.add("show");

//       const CompleteBox = document.querySelector(".custom-atc-wrapper");
//       CompleteBox.classList.add("show");

//       const faqSection = document.querySelector(".faq-section-row");
//       const stickyCart = document.getElementById("sticky-cart");

//       if (faqSection && stickyCart && totalBox) {
//         window.addEventListener("scroll", function () {
//           const faqBottom = faqSection.getBoundingClientRect().bottom;
//           const windowHeight = window.innerHeight;

//           if (totalBox.classList.contains("show")) {
//             if (faqBottom < windowHeight) {
//               stickyCart.classList.add("show");
//             } else {
//                 stickyCart.classList.remove("show");
//             }
//           } else {
//               stickyCart.classList.remove("show");
//           }
//         });
//       }

//     }
//   }

//   function showConfigurationSummary() {
//     const priceContainer = document.querySelector(".price__container[data-price]");
//     const totalBox = document.querySelector(".bold_option_total");

//     if (!priceContainer || !totalBox) {
//       console.warn("⚠️ Price or total box not found");
//       return;
//     }

//     const basePrice = parseFloat(priceContainer.getAttribute("data-price")) / 100 || 0;

//     const checkedInputs = document.querySelectorAll(".bold_option_radio.selected input[type='radio']:checked");
//     let selectedSum = 0;

//     checkedInputs.forEach(input => {
//       const optionValue = input.closest(".bold_option_value");
//       if (optionValue) {
//         const priceEl = optionValue.querySelector(".bold_option_value_price");
//         if (priceEl) {
//           const val = priceEl.textContent.replace(/[^0-9.]/g, "");
//           const num = parseFloat(val);
//           if (!isNaN(num)) selectedSum += num;
//         }
//       }
//     });

//     const total = (basePrice + selectedSum).toFixed(2);


//     const oldSummary = totalBox.querySelector(".config-summary");
//     if (oldSummary) oldSummary.remove();

//     const summaryBox = document.createElement("div");
//     summaryBox.className = "config-summary";
//     summaryBox.innerHTML = `
//       <div class="config-header">
//         <span class="config-header-icon">
//           <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
//             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
//             class="lucide lucide-circle-check-big h-5 w-5 mr-2" aria-hidden="true">
//             <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
//             <path d="m9 11 3 3L22 4"></path>
//           </svg>
//         </span>
//         Configuration Complete - Ready to Add to Cart!
//       </div>
//       <div class="config-line">
//         <span>Base Kit Price:</span>
//         <span class="config-value">$${basePrice.toFixed(2)}</span>
//       </div>
//       <div class="config-line">
//         <span>Selected Options:</span>
//         <span class="config-value option">+${selectedSum > 0 ? "$" + selectedSum.toFixed(2) : "$0.00"}</span>
//       </div>
//       <div class="config-line total">
//         <strong>Total Extras:</strong>
//         <strong class="config-total">$${total}</strong>
//       </div>
//     `;
//     totalBox.classList.add("show");
//     totalBox.appendChild(summaryBox);
//   }
// });
document.addEventListener("DOMContentLoaded", function () {
  const checkInterval = setInterval(() => {
    const options = document.querySelectorAll(".bold_option_radio");

    if (options.length > 0) {
      clearInterval(checkInterval);
      console.log("✅ .bold_option_radio elements loaded");

      // Add step numbers if missing
      document.querySelectorAll(".bold_option_radio .bold_option_title").forEach((title, index) => {
        if (!title.querySelector(".option-number")) {
          const numSpan = document.createElement("span");
          numSpan.className = "option-number";
          numSpan.textContent = `${index + 1}`;
          title.prepend(numSpan);
        }
      });

      // Mark first as active
      options.forEach((o, i) => {
        if (i === 0) o.classList.add("active");
      });

      // Add listeners
      options.forEach(option => {
        const radios = option.querySelectorAll("input[type='radio']");

        // Add both change and click listeners on each radio:
        radios.forEach(radio => {
          // change -> typical flow when selecting a different radio
          radio.addEventListener("change", function (e) {
            if (option.classList.contains("active") && e.target.type === "radio") {
              console.log("radio change detected for option:", option);
              triggerContinue(option);
            }
          });

          // click -> covers case where radio is already checked or single-radio groups
          radio.addEventListener("click", function (e) {
            // small safety: only trigger if this option is currently active
            if (option.classList.contains("active")) {
              // ensure the radio is marked checked before continuing
              // using setTimeout 0 lets the browser update `checked` state first
              setTimeout(() => {
                console.log("radio click detected for option:", option);
                triggerContinue(option);
              }, 0);
            }
          });
        });
      });

      // Edit button handling (same as before)
      document.addEventListener("click", function (e) {
        if (e.target.classList.contains("edit-btn")) {
          e.preventDefault();
          e.stopPropagation();

          const selectedOption = e.target.closest(".bold_option_radio");
          if (!selectedOption) return;

          e.target.remove();

          const radios = selectedOption.querySelectorAll("input[type='radio']");
          radios.forEach(radio => (radio.checked = false));

          document.querySelectorAll(".bold_option_radio").forEach(o => o.classList.remove("active"));
          selectedOption.classList.remove("selected");
          selectedOption.classList.add("active");

          console.log("🟢 Edit clicked — returning to step");
        }
      });
    }
  }, 300);

  function triggerContinue(activeOption) {
    if (!activeOption) return;

    // Prevent double-trigger if already moved to selected (safety)
    if (activeOption.classList.contains("selected")) {
      console.log("Already selected — ignoring trigger for:", activeOption);
      return;
    }

    // mark as done
    activeOption.classList.remove("active");
    activeOption.classList.add("selected");

    const title = activeOption.querySelector(".bold_option_title");
    if (title && !title.querySelector(".edit-btn")) {
      const editBtn = document.createElement("button");
      editBtn.type = "button";
      editBtn.className = "edit-btn";
      editBtn.innerHTML = `<span class="edit-icon">✎</span><span>Edit</span>`;
      title.appendChild(editBtn);
    }

    // go to next
    const nextOption = activeOption.nextElementSibling;
    if (nextOption && nextOption.classList.contains("bold_option_radio")) {
      nextOption.classList.add("active");
      // optional: scroll next into view
      nextOption.scrollIntoView({ behavior: "smooth", block: "center" });
    } else {
      // last step completed: show summary/cart
      const totalBox = document.querySelector(".bold_option_total");
      if (totalBox) totalBox.classList.add("show");

      showConfigurationSummary();

      const stickyCartShow = document.getElementById("sticky-cart");
      if (stickyCartShow) stickyCartShow.classList.add("show");

      const CompleteBox = document.querySelector(".custom-atc-wrapper");
      if (CompleteBox) CompleteBox.classList.add("show");
    }
  }

  function showConfigurationSummary() {
    const priceContainer = document.querySelector(".price__container[data-price]");
    const totalBox = document.querySelector(".bold_option_total");

    if (!priceContainer || !totalBox) {
      console.warn("⚠️ Price or total box not found");
      return;
    }

    const basePrice = parseFloat(priceContainer.getAttribute("data-price")) / 100 || 0;

    const checkedInputs = document.querySelectorAll(".bold_option_radio.selected input[type='radio']:checked");
    let selectedSum = 0;

    checkedInputs.forEach(input => {
      const optionValue = input.closest(".bold_option_value");
      if (optionValue) {
        const priceEl = optionValue.querySelector(".bold_option_value_price");
        if (priceEl) {
          const val = priceEl.textContent.replace(/[^0-9.]/g, "");
          const num = parseFloat(val);
          if (!isNaN(num)) selectedSum += num;
        }
      }
    });

    const total = (basePrice + selectedSum).toFixed(2);

    const oldSummary = totalBox.querySelector(".config-summary");
    if (oldSummary) oldSummary.remove();

    const summaryBox = document.createElement("div");
    summaryBox.className = "config-summary";
    summaryBox.innerHTML = `
      <div class="config-header">Configuration Complete - Ready to Add to Cart!</div>
      <div class="config-line"><span>Base Kit Price:</span><span class="config-value">$${basePrice.toFixed(2)}</span></div>
      <div class="config-line"><span>Selected Options:</span><span class="config-value option">+${selectedSum > 0 ? "$" + selectedSum.toFixed(2) : "$0.00"}</span></div>
      <div class="config-line total"><strong>Total Extras:</strong><strong class="config-total">$${total}</strong></div>
    `;

    totalBox.classList.add("show");
    totalBox.appendChild(summaryBox);
  }
});


function syncPrices() {
  const sourcePrice = document.querySelector('.config-total');
  
  const target1 = document.querySelector('.product-price');
  const target2 = document.querySelector('.sticky-cart__price');
  
  console.log('🔄 Syncing prices to multiple locations...');
  
  if (sourcePrice) {
    if (target1) {
      target1.innerHTML = sourcePrice.innerHTML;
      console.log('✅ Updated .product-price');
    }
    
    if (target2) {
      target2.innerHTML = sourcePrice.innerHTML;
      console.log('✅ Updated .sticky-cart__price');
    }
    
    console.log('💰 Final Price:', sourcePrice.innerHTML);
  } else {
    console.log('❌ Source price not found');
  }
}


document.addEventListener('DOMContentLoaded', function() {
  console.log('📄 DOM loaded - starting price sync');
  setTimeout(syncPrices, 1000);
});

document.addEventListener('change', function(e) {
  if (e.target.matches('input[name="id"], select[name="id"], .product-option input')) {
    console.log('🎛️ Variant changed - updating prices');
    setTimeout(syncPrices, 200);
  }
});

setInterval(syncPrices, 500);

window.syncAllPrices = syncPrices;
console.log('🔧 Price sync available as window.syncAllPrices()');

$(document).ready(function() {
    function toggleBoldOptions() {
        const hasBoldOptionSet = $('.bold_option_set').length > 0;
        const boldOptions = $('.bold_options.bold_options_loaded');
        const addToCartButton = $('.product-form__item--quantity button.addtocart');
        
        console.log('Checking conditions...');
        console.log('bold_option_set exists:', hasBoldOptionSet);
        console.log('bold_options found:', boldOptions.length);
        console.log('addToCart button found:', addToCartButton.length);
        if (!hasBoldOptionSet) {
            console.log('No bold_option_set found, hiding bold_options');
            boldOptions.hide();
            console.log('Showing add to cart button (no bold_option_set)');
            addToCartButton.show();
        } else {
            console.log('bold_option_set found, showing bold_options');
            boldOptions.show();
            console.log('Hiding add to cart button (bold_option_set exists)');
            addToCartButton.hide();
        }
    }
    toggleBoldOptions();
    $(document).on('DOMSubtreeModified', '.bold_options, .bold_option_set, .product-form__item--quantity', toggleBoldOptions);
    $(document).ajaxComplete(function() {
        setTimeout(toggleBoldOptions, 500);
    });
    setInterval(toggleBoldOptions, 2000);
    $(document).on('change', '.bold_option_set input, .bold_option_set select', toggleBoldOptions);
});